/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ActivityDetailResponseDto } from '../model/activityDetailResponse';
// @ts-ignore
import { ActivityFiltersResponseDto } from '../model/activityFiltersResponse';
// @ts-ignore
import { ApiResponseDto } from '../model/apiResponse';
// @ts-ignore
import { PageableActivityResponseDto } from '../model/pageableActivityResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { TollingControllerApiInterface } from './tollingController.serviceInterface';

@Injectable({
    providedIn: 'root',
})
export class TollingControllerApi extends BaseService implements TollingControllerApiInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: Configuration
    ) {
        super(basePath, configuration);
    }

    /**
     * Export activities to csv
     * Export activities to csv
     * @endpoint get /activities/export
     * @param fromDate
     * @param toDate
     * @param vehicle
     * @param vehicleType
     * @param multipleDateFilter
     * @param activityGroupId
     * @param activityIds
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public exportActivities(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        activityGroupId?: string,
        activityIds?: Array<string>,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'text/csv' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<string>;
    public exportActivities(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        activityGroupId?: string,
        activityIds?: Array<string>,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'text/csv' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<string>>;
    public exportActivities(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        activityGroupId?: string,
        activityIds?: Array<string>,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'text/csv' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<string>>;
    public exportActivities(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        activityGroupId?: string,
        activityIds?: Array<string>,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'text/csv' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'fromDate', <any>fromDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'toDate', <any>toDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'vehicle', <any>vehicle, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'vehicleType',
            <any>vehicleType,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'multipleDateFilter',
            <any>multipleDateFilter,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'activityGroupId',
            <any>activityGroupId,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'activityIds',
            <any>activityIds,
            QueryParamStyle.Form,
            true
        );

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['text/csv', '*/*']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/activities/export`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }

    /**
     * getActivities
     * getActivities
     * @endpoint get /activities
     * @param page
     * @param pageSize
     * @param fromDate
     * @param toDate
     * @param vehicle
     * @param road
     * @param vehicleType
     * @param multipleDateFilter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getActivities(
        page?: number,
        pageSize?: number,
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<PageableActivityResponseDto>;
    public getActivities(
        page?: number,
        pageSize?: number,
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<PageableActivityResponseDto>>;
    public getActivities(
        page?: number,
        pageSize?: number,
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<PageableActivityResponseDto>>;
    public getActivities(
        page?: number,
        pageSize?: number,
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'page', <any>page, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'pageSize', <any>pageSize, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'fromDate', <any>fromDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'toDate', <any>toDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'vehicle', <any>vehicle, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'road', <any>road, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'vehicleType',
            <any>vehicleType,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'multipleDateFilter',
            <any>multipleDateFilter,
            QueryParamStyle.Form,
            true
        );

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/activities`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PageableActivityResponseDto>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }

    /**
     * getActivitiesStatement
     * getActivitiesStatement
     * @endpoint get /activities-statement
     * @param vehicle
     * @param road
     * @param vehicleType
     * @param multipleDateFilter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getActivitiesStatement(
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/pdf' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<string>;
    public getActivitiesStatement(
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/pdf' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<string>>;
    public getActivitiesStatement(
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/pdf' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<string>>;
    public getActivitiesStatement(
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/pdf' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'vehicle', <any>vehicle, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'road', <any>road, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'vehicleType',
            <any>vehicleType,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'multipleDateFilter',
            <any>multipleDateFilter,
            QueryParamStyle.Form,
            true
        );

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/pdf', '*/*']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/activities-statement`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }

    /**
     * getActivity
     * getActivity
     * @endpoint get /activities/{id}
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getActivity(
        id: string,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<ActivityDetailResponseDto>;
    public getActivity(
        id: string,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<ActivityDetailResponseDto>>;
    public getActivity(
        id: string,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<ActivityDetailResponseDto>>;
    public getActivity(
        id: string,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getActivity.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/activities/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ActivityDetailResponseDto>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }

    /**
     * getActivityFilters
     * getActivityFilters
     * @endpoint get /activity-filters
     * @param fromDate
     * @param toDate
     * @param vehicle
     * @param road
     * @param vehicleType
     * @param multipleDateFilter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getActivityFilters(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<ActivityFiltersResponseDto>;
    public getActivityFilters(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<ActivityFiltersResponseDto>>;
    public getActivityFilters(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<ActivityFiltersResponseDto>>;
    public getActivityFilters(
        fromDate?: string,
        toDate?: string,
        vehicle?: Array<string>,
        road?: Array<string>,
        vehicleType?: Array<string>,
        multipleDateFilter?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'fromDate', <any>fromDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'toDate', <any>toDate, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'vehicle', <any>vehicle, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, 'road', <any>road, QueryParamStyle.Form, true);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'vehicleType',
            <any>vehicleType,
            QueryParamStyle.Form,
            true
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'multipleDateFilter',
            <any>multipleDateFilter,
            QueryParamStyle.Form,
            true
        );

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/activity-filters`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ActivityFiltersResponseDto>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }
}
